import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { ClipLoader } from 'react-spinners';
import { CircularProgressbar } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';
import { FiSearch, FiLink, FiBarChart, FiImage, FiEdit } from 'react-icons/fi'; // Different icons
import { FaRegLightbulb, FaPen } from 'react-icons/fa';

const SeoAudit = ({ draftId }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [score, setScore] = useState(null);
  const [suggestions, setSuggestions] = useState([]);
  const [error, setError] = useState(null);

  // Trigger the SEO Audit automatically when the component mounts
  useEffect(() => {
    handleSeoAudit();
  }, [draftId]);

  const handleSeoAudit = async () => {
    setIsLoading(true);
    setError(null);
    try {
      const response = await axios.post(`https://trendhopper-c3934b7293e6.herokuapp.com/seo-audit/${draftId}/`);
      setScore(response.data.score);
      setSuggestions(response.data.suggestions);
    } catch (err) {
      setError('Failed to fetch SEO audit results');
    } finally {
      setIsLoading(false);
    }
  };

  const getIconForSuggestion = (suggestion) => {
    // Return appropriate icons based on suggestion content
    if (suggestion.toLowerCase().includes('content quality') || suggestion.toLowerCase().includes('improve writing')) {
      return <FaPen className="text-blue-500 text-2xl" />;
    }
    if (suggestion.toLowerCase().includes('link')) {
      return <FiLink className="text-green-500 text-2xl" />;
    }
    if (suggestion.toLowerCase().includes('seo') || suggestion.toLowerCase().includes('optimization')) {
      return <FiBarChart className="text-orange-500 text-2xl" />;
    }
    if (suggestion.toLowerCase().includes('image')) {
      return <FiImage className="text-purple-500 text-2xl" />;
    }
    return <FaRegLightbulb className="text-yellow-500 text-2xl" />; // Default icon for general improvements
  };

  return (
    <div className="overflow-y-auto p-4 bg-white">
      {/* SEO Score and Refresh Button */}
      <div className="flex justify-center items-center" style={{
        padding:'40px'
      }}>
        <div className="flex items-center gap-2">
          {score !== null && (
            <>
              <CircularProgressbar
                value={score}
                text={`${score}%`}
                styles={{
                  path: {
                    stroke: score > 80 ? '#4caf50' : score > 50 ? '#ffeb3b' : '#f44336',
                    strokeWidth: 10,
                  },
                  text: {
                    fill: '#333',
                    fontSize: '16px',
                    fontWeight: 'bold',
                  },
                }}
              />
            </>
          )}
        </div>
      </div>

      {/* Loading Spinner */}
      {isLoading ? (
        <div className="flex justify-center items-center mt-4">
          <ClipLoader color="#36D7B7" size={50} />
        </div>
      ) : error ? (
        <p className="text-red-500 text-center">{error}</p>
      ) : (
        <>
          {/* Improvement Suggestions Area */}
          <div className="mt-4 overflow-y-auto max-h-[500px]"> {/* Added max-height and overflow-y-auto for scrolling */}
  {suggestions.length > 0 ? (
    <div className="space-y-4">
      {suggestions.map((suggestion, index) => (
        <div
          key={index}
          className="flex items-start space-x-3 p-4 bg-gray-100 rounded-lg shadow-sm hover:shadow-lg transition-all"
        >
          {getIconForSuggestion(suggestion)} {/* Use appropriate icon for each suggestion */}
          <div className="flex-1">
            <p className="text-sm text-gray-700">{suggestion}</p>
          </div>
        </div>
      ))}
    </div>
  ) : (
    <div className="text-gray-500">No suggestions available</div>
  )}
</div>

        </>
      )}
    </div>
  );
};

export default SeoAudit;
